import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Layout from '@/layout/index.vue'

const isElectron = !!(window.electronAPI)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
        meta: { title: '矩阵概况' }
      },
      // {
      //   path: 'dashboard-traffic',
      //   name: 'dashboard-traffic',
      //   component: () => import('@/views/DashboardTraffic.vue'),
      //   meta: { title: '矩阵流量' }
      // },
      {
        path: 'internet-traffic',
        name: 'internet-traffic',
        component: () => import('@/views/traffic/internetTraffic/internetTraffic.vue'),
        meta: { title: '流量概况' }
      },
      {
        path: 'traffic-details',
        name: 'traffic-details',
        component: () => import('@/views/traffic/trafficDetails/trafficDetails.vue'),
        meta: { title: '流量明细' }
      },
      {
        path: 'article-word',
        name: 'article-word',
        component: () => import('@/views/article/KeyWord/index.vue'),
        meta: { title: '关键字' }
      },
      {
        path: 'article-title',
        name: 'article-title',
        component: () => import('@/views/article/TitleView.vue'),
        meta: { title: '标题' }
      },
      {
        path: 'article-rule',
        name: 'article-rule',
        component: () => import('@/views/article/RuleView/RuleView.vue'),
        meta: { title: '内容生成规则' }
      },
      {
        path: 'article-task',
        name: 'article-task',
        component: () => import('@/views/article/TaskView.vue'),
        meta: { title: '创建生成任务' }
      },
      {
        path: 'article-detail',
        name: 'article-detail',
        component: () => import('@/views/article/ArticleDetailView.vue'),
        meta: { title: '文章详情' }
      },
      {
        path: 'article-recommend',
        name: 'article-recommend',
        component: () => import('@/views/article/RecommendView/RecommendView.vue'),
        meta: { title: '个性化单篇文章' }
      },
      {
        path: 'article-deep-create',
        name: 'article-deep-create',
        component: () => import('@/views/article/DeepCreateView/DeepCreateView.vue'),
        meta: { title: '深度文章创作' }
      },
      {
        path: 'business-core-word',
        name: 'business-core-word',
        component: () => import('@/views/article/CoreWordView.vue'),
        meta: { title: '业务核心词' }
      },
      {
        path: 'question-phrase',
        name: 'question-phrase',
        component: () => import('@/views/article/QuestionPhraseView.vue'),
        meta: { title: '问题短语' }
      },
      {
        path: 'auto-creation-task',
        name: 'auto-creation-task',
        component: () => import('@/views/article/AutoCreationTask/AutoCreationTaskView.vue'),
        meta: { title: '自动创作任务' }
      },
      {
        path: 'draft',
        name: 'draft',
        component: () => import('@/views/draft/DraftView.vue'),
        meta: { title: '草稿箱' }
      },
      {
        path: 'publish',
        name: 'publish',
        component: () => import('@/views/publish/PublishView.vue'),
        meta: { title: '自动发布任务' }
      },
      {
        path: 'all-articles',
        name: 'all-articles',
        component: () => import('@/views/articles/AllArticlesView.vue'),
        meta: { title: '所有文章(含草稿箱)' }
      },
      {
        path: 'platform-media',
        name: 'platform-media',
        component: () => import('@/views/platform/MediaView.vue'),
        meta: { title: '内容媒体平台' }
      },
      {
        path: 'platform-create',
        name: 'platform-create',
        component: () => import('@/views/platform/CreateView/index.vue'),
        meta: { title: '自建站平台' }
      },
      {
        path: 'publish-create-add',
        name: 'publish-create-add',
        component: () => import('@/views/publish/AddView.vue'),
        meta: { title: '添加自动发布任务' }
      },
      // 素材库路由
      {
        path: 'materia-library',
        name: 'materia-library',
        component: () => import('@/views/materia/MateriaLibraryView.vue'),
        meta: { title: '素材库' }
      },
      {
        path: 'publish-create-detail/:id',
        name: 'publish-create-detail',
        component: () => import('@/views/publish/DetailView.vue'),
        meta: { title: '自动发布任务详情' }
      },
      // 知识库路由
      {
        path: 'knowledge-base',
        name: 'knowledge-base',
        component: () => import('@/views/knowledge/KnowledgeBaseView.vue'),
        meta: { title: '知识库' }
      },
      // {
      //   path: 'knowledge-base-create',
      //   name: 'knowledge-base-create',
      //   component: () => import('@/views/knowledge/KnowledgeBaseCreateView.vue'),
      //   meta: { title: '创建知识库' }
      // },
      // {
      //   path: 'knowledge-base-detail/:id',
      //   name: 'knowledge-base-detail',
      //   component: () => import('@/views/knowledge/KnowledgeBaseDetailView.vue'),
      //   meta: { title: '知识库详情' }
      // },
      // {
      //   path: 'knowledge-base-edit/:id',
      //   name: 'knowledge-base-edit',
      //   component: () => import('@/views/knowledge/KnowledgeBaseEditView.vue'),
      //   meta: { title: '编辑知识库' }
      // },
      // 账号管理路由
      {
        path: 'account-management',
        name: 'account-management',
        component: () => import('@/views/account/AccountManagementView.vue'),
        meta: { title: '账号管理' }
      },
      // {
      //   path: 'account-management-add',
      //   name: 'account-management-add',
      //   component: () => import('@/views/account/AccountManagementAddView.vue'),
      //   meta: { title: '添加账号' }
      // },
      // {
      //   path: 'account-management-edit/:id',
      //   name: 'account-management-edit',
      //   component: () => import('@/views/account/AccountManagementEditView.vue'),
      //   meta: { title: '编辑账号' }
      // },
      // 账户充值/算力充值路由
      {
        path: 'account-recharge',
        name: 'account-recharge',
        component: () => import('@/views/account/AccountRechargeView.vue'),
        meta: { title: '账户充值/算力充值' }
      },
      {
        path: 'notice-sign',
        name: 'notice-sign',
        component: () => import('@/views/notice/NoticeSignView.vue'),
        meta: { title: '站内通知' }
      },
      {
        path: 'brand-management',
        name: 'brand-management',
        component: () => import('@/views/brand/BrandManagement.vue'),
        meta: { title: '品牌管理' }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue')
  }
]

const router = createRouter({
  history: isElectron ? createWebHashHistory() : createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  console.log('路由守卫检查:', {
    to: to.path,
    from: from.path,
    token: token ? '存在' : '不存在'
  })
  
  const publicPaths = ['/login', '/register', '/forgot-password']

  if (!publicPaths.includes(to.path) && !token) {
    console.log('重定向到登录页: token不存在')
    next('/login')
  } else {
    console.log('允许访问:', to.path)
    next()
  }
})

export default router
